import React, { Component } from 'react'
import gql from 'graphql-tag'
import { compose, graphql } from 'react-apollo'
import ProjectForm from '../components/ProjectForm'
import history from '../../../../../../history'

const GET_PROJECT_QUERY = gql`query GetProjects($id: ID!) {
    project(id: $id) {
        id
        name
        color
    }
}`

const EDIT_PROJECT_MUTATION = gql`mutation EditProject($id: ID!, $data: ProjectInput) {
    updateProject(id: $id, data: $data) {
        id
        name
        color
    }
}`

const DELETE_PROJECT_MUTATION = gql`mutation DeleteProject($id: ID!) {
    deleteProject(id: $id)
}`

type Props = {
  editMutate: Function,
  deleteMutate: Function,
  data: Object
}

class Edit extends Component<Props> {
  constructor (props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
    this.onDeleteConfirm = this.onDeleteConfirm.bind(this)
  }

  async onDeleteConfirm () {
    try {
      const {deleteMutate, data} = this.props
      const {project} = data
      const result = await deleteMutate({variables: {id: project.id}})
      history.goBack()
    } catch (e) {
      console.log(e)
    }
  }

  async onSubmit (values, { setSubmitting }) {
    try {
      const { data } = this.props
      const { project } = data

      const result = await this.props.editMutate({
        variables: {
          id: project.id,
          data: {
            name: values.name,
            color: values.color
          }
        }
      })
      history.goBack()
    } catch (e) {
      console.error('errore', e)
    }
  }

  render () {
    const { data } = this.props
    const { loading } = data
    return (
      <div className="col-12">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">Modifica Progetto</h1>
        </div>
        <div className="col-8 offset-2">
          {loading ? (
            <span>Caricamento in corso...</span>
          ) : (
            <ProjectForm
              initialValues={data.project}
              onSubmit={this.onSubmit}
            />
          )}
          <button
            style={{marginTop: '20px'}}
            className="btn btn-danger"
            onClick={this.onDeleteConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(GET_PROJECT_QUERY, {
    options: ({match}) => ({ variables: { id: match.params.id } })
  }),
  graphql(EDIT_PROJECT_MUTATION, { name: 'editMutate' }),
  graphql(DELETE_PROJECT_MUTATION, { name: 'deleteMutate' })
)(Edit)
